import { DEFAULT_WA_MESSAGE } from "./brand";
import { getBrand } from "./siteConfig";

/**
 * Generate a WhatsApp URL with a pre-filled quotation message.
 * All params optional; only non-empty ones are included.
 */
export function generateWhatsAppUrl(params = {}) {
  const {
    name,
    phone,
    service,
    propertyType,
    floorArea,
    bedrooms,
    preferredDate,
    location,
    promotion,
    message,
  } = params;

  const lines = [];
  if (service || name || phone) {
    lines.push("Hi Emilio's Solutions, I would like to request a quotation.");
    lines.push("");
  } else {
    lines.push(DEFAULT_WA_MESSAGE);
  }

  if (name) lines.push(`Name: ${name}`);
  if (phone) lines.push(`Mobile: ${phone}`);
  if (service) lines.push(`Service: ${service}`);
  if (propertyType) lines.push(`Property Type: ${propertyType}`);
  if (floorArea) lines.push(`Floor Area: ${floorArea}`);
  if (bedrooms) lines.push(`Bedrooms: ${bedrooms}`);
  if (preferredDate) lines.push(`Preferred Date: ${preferredDate}`);
  if (location) lines.push(`Location: ${location}`);
  if (promotion) lines.push(`Promotion: ${promotion}`);
  if (message) {
    lines.push("");
    lines.push(`Additional Details: ${message}`);
  }

  const text = encodeURIComponent(lines.join("\n"));
  return `${getBrand().whatsapp}?text=${text}`;
}

export function whatsappForService(serviceName) {
  return generateWhatsAppUrl({ service: serviceName });
}

export function whatsappForPromotion(promotionTitle, customMessage) {
  const msg =
    customMessage ||
    `Hi Emilio's Solutions, I would like to know more about the "${promotionTitle}" promotion.`;
  const text = encodeURIComponent(msg);
  return `${getBrand().whatsapp}?text=${text}`;
}
